import React, { useState } from "react";
import "../rnr.css";
import Table from 'react-bootstrap/Table';

export default function Settings() {
      
  return (
    <div>
      <main className="flex-shrink-0">
        <div className="container">
          <h4 className="mt-3">Settings</h4>
            <div style={{display: 'block', width: '100%'}}>
              <br />
              <Table size="sm" className="table table-borderless">
                <tbody>
                  <tr>
                    <td className="col-md-3"><strong>Discount Rate:</strong></td>
                    <td className="col-md-9">1% p.a.</td>
                  </tr>
                  <tr>
                    <td className="col-md-3"><strong>No. of Pricing Scenarios:</strong></td>
                    <td className="col-md-9">12000</td>
                  </tr>
                </tbody>
              </Table>
            </div>
        </div>
      </main>
    </div>
  );
}
